import React from 'react'

function Process() {
  return (
            <span clsssName="pt-120" style={{paddingTop:"200px"}} id="process">
                <section className="features__area pt-120 pb-120">
                    <div className="container">
                        <div className="row mt-none-30">
                            <div className="col-xl-3 col-lg-3 col-md-6">
                                <div className="services__box services__box--2 mt-30">
                                    <span className="number">01</span>
                                    <h4 className="serv__title">Discovery</h4>
                                    <p>We start by understanding your unique needs and goals through a detailed consultation.</p>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-6">
                                <div className="services__box services__box--2 mt-30">
                                    <span className="number">02</span>
                                    <h4 className="serv__title">Tailored Solutions</h4>
                                    <p>Our team designs customized HR strategies and solutions based on your specific requirements.</p>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-6">
                                <div className="services__box services__box--2 mt-30">
                                    <span className="number">03</span>
                                    <h4 className="serv__title">Implementation</h4>
                                    <p>We work closely with you to implement the strategies effectively, ensuring smooth integration and adoption.</p>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-3 col-md-6">
                                <div className="services__box services__box--2 mt-30">
                                    <span className="number">04</span>
                                    <h4 className="serv__title">Ongoing Support</h4>
                                    <p>We provide continuous support and adjustments as needed to ensure long-term success and satisfaction.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </span>  
  )
}

export default Process
